import { fetchList as fetchCity, fetchBsList } from '@/api/city'
import request from "@/api/request";
export function fetchCityNew() {
    return request({
        url: '/market-service/scrm/company/address',
        method: 'post',
    })
}
export default {
    data() {
        return {
            cityList: [],
            bcCityList: [],
            rawCityList: [],
        }
    },
    mounted() {
        fetchCity().then(res => {
            if (Array.isArray(res)) {
                this.rawCityList = Object.freeze(res)
                this.cityList = this.buildTree(Object.freeze(res), null)
            }
        })
        fetchBsList({pid: '-1'}).then(res => {
            if (Array.isArray(res)) {
                this.rawCityList = Object.freeze(res)
                this.bcCityList = this.buildTree(Object.freeze(res), '-1')
            }
        })
    },
    methods: {
        buildTree(list, pid) {
            const tree = [];
            list.forEach((item) => {
                if (item.pid === pid) {
                    let children = this.buildTree(list, item.id);

                    let params = {
                        ...item,
                        key: item.id,
                        value: item.name,
                        label: item.name,
                    }

                    if (children.length > 0) {
                        params.children = children;
                    } else {
                        delete params.children;
                    }

                    tree.push(params);
                }
            });

            return tree;
        }

    }
}